export default __webpack_public_path__ + "static/media/kingshiba.4fcca540.png";